import { Component, EventEmitter, Input, Output, OnDestroy, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ParkingCardInfo } from '../../../../../../../core/models/information.model';
import { LanguageService } from '../../../../../../../core/services/language.service';
import { Subscription } from 'rxjs';
import { MyVehicleSelectComponent } from '../my-vehicle-select/my-vehicle-select.component';
import { MyVehicleAllForChange } from '../../../../../../../core/models/user.model';

@Component({
  selector: 'app-setting-mycard-modal',
  standalone: true,
  imports: [CommonModule, MyVehicleSelectComponent],
  templateUrl: './setting-mycard-modal.component.html',
  styleUrl: './setting-mycard-modal.component.css'
})
export class SettingMycardModalComponent implements OnInit, OnChanges, OnDestroy {

  @Input() card: ParkingCardInfo | null = null;
  @Input() isOpen: boolean = false;

  @Output() close = new EventEmitter<void>();
  @Output() requestChangePlate = new EventEmitter<{ card: ParkingCardInfo, selectedVehicle: MyVehicleAllForChange }>();

  currentLang: 'TH' | 'EN' = 'TH';
  sub!: Subscription;
  isVehicleSelectOpen: boolean = false;

  constructor(private languageService: LanguageService) {
    console.log('SettingMycardModalComponent constructor');

    this.sub = this.languageService.currentLang$.subscribe((lang) => {
      console.log('Language changed:', lang);
      this.currentLang = lang;
    });
  }

  ngOnInit() {
    console.log('SettingMycardModalComponent ngOnInit');
    console.log('Initial card:', this.card);
    console.log('Initial isOpen:', this.isOpen);
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('card data:', this.card);
    console.log(this.card?.myVehicles);
  }

  ngOnDestroy() {
    console.log('SettingMycardModalComponent destroyed');

    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  onClose() {
    console.log('Modal closed');
    this.close.emit();
  }

  onChangePlate() {
    console.log('Change plate clicked');

    if (this.card) {
      console.log('Opening vehicle select for card:', this.card);
      this.isVehicleSelectOpen = true;
    }
  }

  closeVehicleSelect() {
    console.log('Vehicle select modal closed');
    this.isVehicleSelectOpen = false;
  }

  onConfirmVehicleSelect(event: { card: ParkingCardInfo, selectedVehicle: MyVehicleAllForChange }) {
    console.log('Vehicle selected:', event);

    this.isVehicleSelectOpen = false;
    this.requestChangePlate.emit(event);
  }
}